export const GAME_CATEGORIES = [
	'casino',
	'favorites',
	'featurebuyin',
	'gameshows',
	'hotlive',
	'hotslots',
	'livecasino',
	'newgames',
	'populargames',
	'recentlyplayed',
	'slots',
	'table_games'
] as const;
export type GameCategory = (typeof GAME_CATEGORIES)[number];
